import { useState } from "react";
import { emojiPacks, sillyImages, memeImages } from "@/mocks/homeData";
import type { MemeItem } from "@/mocks/homeData";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import HotZone from "./components/HotZone";
import MemeGallery from "./components/MemeGallery";
import AvatarSection from "./components/AvatarSection";
import WallpaperSection from "./components/WallpaperSection";
import PeripheralSection from "./components/PeripheralSection";
import BattleZone from "./components/BattleZone";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import Lightbox from "./components/Lightbox";

interface LightState {
  item: MemeItem;
  aspect: string;
}

export default function Home() {
  const [light, setLight] = useState<LightState | null>(null);

  const openSquare = (item: MemeItem) => setLight({ item, aspect: "aspect-square" });
  const openWall = (item: MemeItem) => setLight({ item, aspect: "aspect-video" });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <HotZone />
        <MemeGallery
          id="emoji"
          eyebrow="表情包图鉴"
          title="斗图神图 一网打尽"
          desc="按热门、最新、萌系、搞怪快速筛选，挑一套顺手的神图，让聊天永远不缺弹药。"
          items={emojiPacks}
          onOpen={openSquare}
          accent="primary"
          bg="bg-background-50"
        />
        <MemeGallery
          id="silly"
          eyebrow="沙雕图合集"
          title="快乐源泉 越看越上头"
          desc="神回复、生活日常、离谱瞬间……沙雕图分区每天都有新素材，笑点低的慎入。"
          items={sillyImages}
          onOpen={openSquare}
          accent="secondary"
          bg="bg-background-100/70"
        />
        <MemeGallery
          id="meme"
          eyebrow="热梗梗图"
          title="热梗名场面追踪"
          desc="紧跟网络热梗与名场面，职场与互动梗图一应俱全，回击更有分寸也更有梗。"
          items={memeImages}
          onOpen={openSquare}
          accent="accent"
          bg="bg-background-50"
        />
        <AvatarSection onOpen={openSquare} />
        <WallpaperSection onOpen={openWall} />
        <PeripheralSection onOpen={openSquare} />
        <BattleZone />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
      <BackToTop />
      <Lightbox
        item={light?.item ?? null}
        aspectClass={light?.aspect ?? "aspect-square"}
        onClose={() => setLight(null)}
      />
    </div>
  );
}